import { EHttpMethods } from "../../../../enums";
import { AppProvider } from "../../../../providers/app/app.provider";
import {
  AUTH_BASE_URL,
  FEEDBACK_URL,
  GET_CHECK_FEEDBACK,
} from "../../../constants";
import { getToken } from "../../../context/authContext";
import { AuthConfig } from "../../../context/config/authConfig";
import { ApiServiceManager, fetchRequest } from "../../apiServiceManager";
import { IApiResponse } from "../../models";
import { IPostFeedBackRequest, IPostFeedbackResponse } from "./models";

const defaultProvide = () => getToken();
const appProvide = async () => AuthConfig.getAppToken();

export const fetchFeedbackReview = (
  id: string | number,
  pageNumber: number,
  pageSize: number,
  publicApi?: boolean
): Promise<IApiResponse> => {
  const descriptor = new ApiServiceManager(
    `${AUTH_BASE_URL}${FEEDBACK_URL}/${id}?page=${pageNumber}&size=${pageSize}`,
    EHttpMethods.GET,
    publicApi ? appProvide : defaultProvide
  );
  return fetchRequest(descriptor, null);
};

export const checkFeedBack = (userId, contractId): Promise<IApiResponse> => {
  const url = `${AUTH_BASE_URL}${GET_CHECK_FEEDBACK(userId, contractId)}`;
  const descriptor = new ApiServiceManager(
    url,
    EHttpMethods.GET,
    defaultProvide
  );
  return fetchRequest(descriptor);
};

export const postFeedBack = (
  body: IPostFeedBackRequest
): Promise<IPostFeedbackResponse> => {
  const url = `${AUTH_BASE_URL}${FEEDBACK_URL}`;
  const descriptor = new ApiServiceManager(
    url,
    EHttpMethods.POST,
    defaultProvide
  );
  return fetchRequest(descriptor, body);
};
